import { render, staticRenderFns } from "./adminPayFeeDetailList.vue?vue&type=template&id=a066fa3c&scoped=true"
import script from "./adminPayFeeDetailList.vue?vue&type=script&lang=js"
export * from "./adminPayFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminPayFeeDetailList.vue?vue&type=style&index=0&id=a066fa3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a066fa3c",
  null
  
)

export default component.exports